<template>
  <div class="wrapper">
    <div class="content-container">
      <div class="stingy-card">
        <h2>🎉 Comprehensive Risk - Something us cats know all about 🎉</h2>

        <p>🌟 "Welcome to the captivating world of RiskyPaws, where every leap and every purr resonates with the subtle yet ever-present echoes of risk. Here, we embark on a whisker-tingling journey, exploring how risk, like a stealthy cat, is an omnipresent companion in our lives. From the tiniest choices we make each day, like which toy to chase, to the monumental decisions that shape our financial futures, risk plays a pivotal role. 🐾</p>

  
        <p> In the enchanting realm of RiskyPaws, we don’t just talk about risk; we dance with it, under the moonlit sky of possibilities. It's not just a factor in our financial investments or a shadow in our personal endeavors; it's the thread that weaves through the tapestry of our lives. 🌌

          Understanding risk in its entirety is like learning the language of cats – complex, multifaceted, but oh-so-rewarding. By mastering this language, we learn to make choices that are not only informed but also aligned with the rhythm of our unique life melodies. Each purr, each meow, and each leap in RiskyPaws is a step towards understanding the art of risk, transforming the intimidating into the intriguing, and the overwhelming into opportunities for growth and prosperity. 🌠
</p>
  Think about how you respond internally when faced with risk.   Humans generally have 3 well-known mechanisms to deal with risk, fear or stress: fight, flight or freeze.  
  
  <div class="cat-risks">
      <h2>Cats' Four Mechanisms of Handling Risk:</h2>
      <ul>
        <li><strong>Flight:</strong> Withdrawing from the threat.</li><br>
        <li><strong>Fight:</strong> Defensive aggression.</li><br>
        <li><strong>Freeze:</strong> Crouching and lying still to avoid attention.</li><br>
        <li><strong>Appeasement:</strong> Actively submitting to the aggressor. This is noticeable when your adorable fluff ball falls to the ground with their tummy exposed. They don't see you as a true threat but still, having a large human bearing down on you, it's easier to submit.</li>
      </ul>
    </div>

  Here is an incredible example of a life or death risky situation.  A cat jumps out of a 5 storey burning building as it's aware that it would land on its feet.  Luckily it did and survived unscathed.  By preparing to know how we will respond in risky situations it helps when they unevitably arise. 

  <div class="video-container">
    <video controls>
      <source :src="videoUrl" type="video/mp4">
      Your browser does not support the video tag.
    </video>
  </div>
    </div>
</div></div><br><br><br><br><br><br>
     
</template>


<script>
import { ref } from 'vue';
import catFallingVideo from '@/assets/catfalling.mp4';

export default {
  setup() {
    const videoUrl = ref(catFallingVideo);

    return { videoUrl };
  }
};
</script>



<style scoped>
.wrapper {
display: flex;
flex-direction: column;
align-items: center;
}
.video-container {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  padding-top: 25px;
  height: 0;
}

.video-container video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.content-container {
background-color: #4A148C ;  /* Light orange color */
color: black;
padding: 20px;
border-radius: 20px;  /* Adjust this value to your preference */
overflow: hidden; 
}
.stingy-card {
flex: 1;  /* Take up equal width as the iframe */
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white
}

.stylish-links {
background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
padding: 20px;
border-radius: 10px;
box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.stylish-links h3 {
color: #333;
font-size: 1.4em;
margin-bottom: 15px;
}

.stylish-links ul {
list-style: none;
padding: 0;
}

.stylish-links ul li {
background-color: #fff;
margin: 10px 0;
padding: 10px;
border-radius: 8px;
box-shadow: 0 2px 4px rgba(0,0,0,0.1);
transition: all 0.3s ease;
}

.stylish-links ul li a {
color: black;
text-decoration: none;
font-weight: bold;
}

.stylish-links ul li:hover {
background-color: #4A148C;
}

.stylish-links ul li:hover a {
color: #fff;
}
</style>